import { PlusOutlined } from '@ant-design/icons';
import { Input, Space, Tag } from 'antd';
import React, { useEffect, useRef, useState } from 'react';

const ListInput = ({ value, onChange, disabled = false }) => {
  const [tags, setTags] = useState(Array.isArray(value) ? value : []);
  const [inputVisible, setInputVisible] = useState(false);
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  // Synchroniser les tags avec la valeur externe
  useEffect(() => {
    if (Array.isArray(value)) {
      setTags(value);
    }
  }, [value]);

  // Focus sur l'input quand il devient visible
  useEffect(() => {
    if (inputVisible) {
      inputRef.current?.focus();
    }
  }, [inputVisible]);

  const handleClose = (removedTag) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    setTags(newTags);
    onChange?.(newTags);
  };

  const showInput = () => {
    setInputVisible(true);
  };

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleInputConfirm = () => {
    if (inputValue && !tags.includes(inputValue)) {
      const newTags = [...tags, inputValue];
      setTags(newTags);
      onChange?.(newTags);
    }
    setInputVisible(false);
    setInputValue('');
  };

  const handleInputBlur = () => {
    handleInputConfirm();
  };

  return (
    <Space
      size={[0, 8]}
      wrap
      style={{
        width: '100%',
        minHeight: 32,
        padding: '0 11px',
        border: '1px solid #d9d9d9',
        borderRadius: '6px',
        backgroundColor: disabled ? '#f5f5f5' : '#fff',
      }}
    >
      {tags.map((tag) => (
        <Tag
          style={{
            zIndex: 99,
          }}
          key={tag}
          closable={!disabled}
          onClose={(e) => {
            e.preventDefault();
            handleClose(tag);
          }}
        >
          {tag}
        </Tag>
      ))}
      {inputVisible ? (
        <Input
          ref={inputRef}
          type="text"
          size="small"
          style={{
            width: 78,
            height: 22,
            marginInlineEnd: 8,
            verticalAlign: 'top',
          }}
          value={inputValue}
          onChange={handleInputChange}
          onBlur={handleInputBlur}
          onPressEnter={handleInputConfirm}
          disabled={disabled}
        />
      ) : (
        <Tag
          onClick={showInput}
          style={{
            background: '#fff',
            borderStyle: 'dashed',
            cursor: disabled ? 'not-allowed' : 'pointer',
          }}
          disabled={disabled}
        >
          <PlusOutlined /> Ajouter une valeur
        </Tag>
      )}
    </Space>
  );
};

export default ListInput;
